module.exports = __webpack_public_path__ + "img/file-type-ppt-alt.90d73d79.svg";